import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { reloadUserInfo, userInfoSuccess } from '../actions/auth.actions';
import { UserInfoService } from '../user-info.service';

@Injectable()
export class ReloadUserInfoEffect {
  constructor(
    private actions$: Actions,
    private userInfoService: UserInfoService
  ) {}

  fetchUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reloadUserInfo),
      switchMap(() => this.userInfoService.get()),
      map(attributes => userInfoSuccess({ attributes }))
    )
  );
}
